import ChatService from "../services/chat";

async function fetchActiveUsers(chatId, recipients) {
  const { data: activeRecipients } = await ChatService.getUsers(chatId);

  return recipients.map((recipient) => {
    const isActive = activeRecipients.some(
      (activeRecipient) =>
        activeRecipient.username === recipient.user?.username
    );

    return {
      ...recipient,
      isActive,
    };
  });
}

export default fetchActiveUsers;
